import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { CommunicationEventPurposeType } from '../../children/model/student-communication-events';

@Injectable({
  providedIn: 'root'
})
export class CommunicationEventPurposeTypeEntityService extends EntityCollectionServiceBase<CommunicationEventPurposeType> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('CommunicationEventPurposeType', serviceElementsFactory);
  }
}